<template>
  <div id="OurStorySection">
    <section class="section" style="background-color: #0a0a0a; color: white;">
      <div class="container">
        <p class="subtitle" style="color: #c7c7c7">
          Secret Storey sprung into life late in 2019 and gained reputation as
          one of Bangkok’s popular “speakeasy” bars. The bar itself can clearly
          be seen from the platform of BTS Phrom Phong station, but it isn’t
          obvious at first glance exactly where the entrance is!
          <br />
          <br />
          The entire experience from wandering down the hidden backstreet in
          Sukhumvit 24, to find the black staircase, to tasting the first sip of
          a specialty cocktail – is an absolute privilege and delight. Anchored
          by state-of-the-art projection mapping on the ceiling, every element
          is a modern adaptation of design that transports you to another world.
          <br />
          <br />

          Secret Storey is definitely one of the first of its kind. The bar is
          no longer a bar. It’s a stage, a dance floor, a theatre, or even a
          dynamic fashion shoot space! We strive to offer an exceptional
          experience through a whirlwind of unique event styles and moods – from
          drag queen shows to live music or DJ, and creative, seasonal and
          thought provoking cocktails. Escape from everyday life with Happy Hour
          every day between 17.00-20.00. If you are looking for a place for a
          private event - Our space makes every occasion special with great
          value promotional packages. Please feel free to contact us for more
          detail.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "OurStorySection"
};
</script>

<style></style>
